const PRIMARY_COLORS = {
    default: "#0db4ac",
    "dark-blue": "#001c2f",
    white: "#009a4e",
    yellow: "#e2e046",
    "red-gray": "#00AF66",
    "energy-blue": "#1c75bc",
    "dark-orange": "#f89e00",
    "dark-green": "#55af3a",
    "green-gray": "#009640",
    "white-gray": "#FC0000",
    "yellow-blue": "#FBB116",
    "dark-yellow-blue": "#79cad8",
    "blue-green": "#B3ED00",
    "energy-cyan": "#00A796",
    "dark-cyan": "#6AF9CD",
    "white-blue": "#fff",
    "dark-light-blue": "#4DC0DF",
    "blue-orange": "#4DC0DF",
    "emerald-white": "#004c40",
    "blue-gold": "#668cfc",
    "mid-green": "#02d683",
    "navy-gold": "#f5b52a",
    "charcoal-blue": "#00a1fd",
}

const SECONDARY_COLORS = {
    default: "#1d2832",
    "dark-blue": "#28d5f9",
    white: "#fff",
    yellow: "#141414",
    "red-gray": "#333f48",
    "energy-blue": "#000000",
    "dark-orange": "#232323",
    "dark-green": "#231f20",
    "green-gray": "#535353",
    "white-gray": "#EEEEED",
    "yellow-blue": "#231f20",
    "dark-yellow-blue": "#333F48",
    "blue-green": "#1F1F1F",
    "energy-cyan": "#024053",
    "dark-cyan": "#1E2025",
    "white-blue": "#2d458c",
    "dark-light-blue": "#646464",
    "blue-orange": "#646464",
    "emerald-white": "#D0E2E4",
    "blue-gold": "#141f3d",
    "mid-green": "#002a20",
    "navy-gold": "#1d2832",
    "charcoal-blue": "#161717",
}

const BACKGROUND_COLORS = {
    default: "#283542",
    "dark-blue": "#001420",
    white: "#ffffff",
    yellow: "#000d15",
    "red-gray": "#333F48",
    "energy-blue": "#0c0c0c",
    "dark-orange": "#063642",
    "dark-green": "#231f20",
    "green-gray": "#535353",
    "white-gray": "#EEEEED",
    "yellow-blue": "#231f20",
    "dark-yellow-blue": "#333F48",
    "blue-green": "#141414",
    "energy-cyan": "#005671",
    "dark-cyan": "#1E2025",
    "white-blue": "#fff",
    "dark-light-blue": "#0c0c0c",
    "blue-orange": "#113355",
    "emerald-white": "#d0e2e4",
    "blue-gold": "#091635",
    "mid-green": "#002a20",
    "navy-gold": "#283542",
    "charcoal-blue": "#191a1a",
}

module.exports = {
    PRIMARY_COLORS,
    SECONDARY_COLORS,
    BACKGROUND_COLORS,
}
